export default __webpack_public_path__ + "static/media/G0006.1d9e95a9.png";